// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1wn-f","description":"PatientConsentPreview_description__1BDZA"};